'use client';

import { CalculatorId, CalculatorType, type CalculatorConfig } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';
import { barGraphConfig } from '../bar-graph/bar-graph.config';

export const columnGraphConfig: CalculatorConfig<CalculatorId.ColumnChart> = {
  ...barGraphConfig,
  id: CalculatorId.ColumnChart,
  type: CalculatorType.Graph,
  name: 'Column Chart',
  initialData: TableDataJSON.from({
    columns: [
      { id: 'month', name: 'Month', values: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
      { id: 'sales', name: 'Sales', values: ['120', '150', '200', '180', '130', '160'] },
      { id: 'profit', name: 'Profit', values: ['45', '60', '75', '65', '50', '55'] }
    ]
  }),
  initialControlValues: {
    category: 'month',
    values: ['sales', 'profit'],
    barLayout: 'grouped',
    orientation: 'vertical',
    title: 'Monthly Sales and Profit',
    barWidth: 40,
    enableShadow: 'true'
  }
}; 